import { memo } from 'react';

/**
 * Makes memo able to infer all the types from the passed in component
 *
 * We might revisit this if we ever do any additional checking on the return
 * value, but we don't do that anywhere currently.
 */
export const typedMemo: <T>(c: T) => T = memo;
